import { Suspense } from "react";
import { Route, Redirect, Link } from "react-router-dom";
import { adminPortalRedirectionLink } from "../../../config/config";

const AuthenticatedRoute = ({ path, isAuth, Component, ...rest }: any): JSX.Element => {
	const urlElements = window.location.href.split("/");
	// console.log("urlElements Redirect", urlElements);
	return (
		<Route
			path={path}
			{...rest}
			render={(props: any) =>
				isAuth !== null ? (
					<Suspense fallback={<div />}>
						<Component {...props} />
					</Suspense>
				) : (
					<Redirect to={window.location.replace(`${adminPortalRedirectionLink}/login`) as any} />
					// <Route
					// 	exact
					// 	render={(props: any) => {
					// 		// window.location.replace(`${adminPortalRedirectionLink}/login`);
					// 	}}
					// />
				)
			}
		/>
	);
};

export default AuthenticatedRoute;
